import Papa from "papaparse";
import _, { isEmpty } from "lodash";
import { VolumeUnitConverter } from "../util/VolumeUnitConvertor";
import { getCreateOrderRequests } from "../util/CreateOrderRequestGenerator";

export const parserOrderCsv = (orderFile, version) => {
  let createOrderRequests = [];
  let skipEmptyLineStartIndex = null;
  let rowIndex = -1;
  const volumeUnitConverter = new VolumeUnitConverter("CCM", "CM");

  return new Promise((resolve, reject) => {
    Papa.parse(orderFile, {
      header: true,
      skipEmptyLines: true,
      transformHeader: (header) => {
        return header.trim();
      },
      error: () => {
        return reject({ errors: ["File Processing Failed!"] });
      },
      step: ({ data, meta }) => {
        rowIndex = rowIndex + 1;

        // Validate columns
        if (createOrderRequests.length === 0) {
          const columnErrors = [];
          const requiredColumns = ["CUSTOMER_ORDER_NO"];

          // TODO: Add more validations here
          requiredColumns.forEach((field) => {
            if (meta?.fields.indexOf(field) < 0)
              columnErrors.push(`Column ${field} is missing`);
          });
          if (columnErrors.length > 0) return reject({ errors: columnErrors });
        }

        if (isEmpty(data["CUSTOMER_ORDER_NO"])) {
          return reject({
            errors: [
              `Row ${rowIndex + 1}: CUSTOMER_ORDER_NO for row ${rowIndex + 1} is invalid`,
            ],
          });
        }

        //Mapping rows to order requests
        const createOrderRequest = getCreateOrderRequests(
          data,
          volumeUnitConverter,
          version
        );

        //removing row object keys with empty values
        const newRowData = _.omitBy(
          createOrderRequest,
          (value) => value === null
        );

        //counting the start of the empty line index
        if (Object.keys(newRowData).length === 0) {
          if (!skipEmptyLineStartIndex) skipEmptyLineStartIndex = rowIndex;
        } else skipEmptyLineStartIndex = null;

        createOrderRequests.push(newRowData);
      },
      complete: () => {
        //removing the empty rows at the end
        if (skipEmptyLineStartIndex) {
          createOrderRequests = createOrderRequests.splice(
            0,
            skipEmptyLineStartIndex
          );
        }

        let uniqueOrders = createOrderRequests.filter(
          (order, index, self) =>
            index === self.findIndex((t) => t.id === order.id)
        );

        return resolve({
          data: {
            createOrderRequests: uniqueOrders,
          },
        });
      },
    });
  });
};
